export const useList = <I>(byId: ById<I>): I[] => {
  return React.useMemo(() => list(byId), [byId])
}

export const list = <I>(byId: ById<I>): I[] => Object.values(byId) as I[]
